module.exports = __webpack_public_path__ + "img/idigi-bull-logo-old.931d6ac2.png";